const WealthEmpireMock = () => {
  const businesses = [
    { name: "Lemonade Stand", icon: "🍋", level: 12, income: "$0.50/s", progress: 78, color: "#FFD700" },
    { name: "Pizza Shop",     icon: "🍕", level: 8,  income: "$3.20/s", progress: 55, color: "#FF4757" },
    { name: "Car Wash",       icon: "🚗", level: 5,  income: "$12/s",   progress: 32, color: "#3EAEFF" },
    { name: "Hotel",          icon: "🏨", level: 3,  income: "$80/s",   progress: 18, color: "#A855F7" },
  ];

  return (
    <div style={{
      width: 280,
      background: "#0D1117",
      borderRadius: 36,
      border: "2px solid rgba(255,215,0,0.2)",
      overflow: "hidden",
      boxShadow: "0 40px 80px #000a, 0 0 40px #FFD70022",
      position: "relative",
    }}>
      {/* Header */}
      <div style={{
        background: "linear-gradient(135deg, #1a1200, #2a1a00)",
        padding: "10px 16px 12px",
        borderBottom: "1px solid rgba(255,215,0,0.12)",
        textAlign: "center",
      }}>
        <div style={{ color: "#FFD700", fontSize: 18, fontWeight: 800, fontFamily: "'Fredoka One', cursive", letterSpacing: 0.5 }}>
          💰 Wealth Empire
        </div>
      </div>

      {/* Stats Bar */}
      <div style={{ background: "#111820", padding: "8px 10px", display: "flex", gap: 6, justifyContent: "center" }}>
        {[["BALANCE","$2.4M"],["INCOME","$96/s"],["LEVEL","28"]].map(([l,v]) => (
          <div key={l} style={{ flex: 1, background: "rgba(255,215,0,0.07)", borderRadius: 10, padding: "6px 4px", textAlign: "center", border: "1px solid rgba(255,215,0,0.1)" }}>
            <div style={{ color: "rgba(255,255,255,0.4)", fontSize: 8, letterSpacing: 0.5 }}>{l}</div>
            <div style={{ color: "#FFD700", fontSize: 13, fontWeight: 700 }}>{v}</div>
          </div>
        ))}
      </div>

      {/* Business List */}
      <div style={{ padding: "8px 10px", background: "#0D1117", display: "flex", flexDirection: "column", gap: 7 }}>
        {businesses.map((b) => (
          <div key={b.name} style={{
            background: "rgba(255,255,255,0.04)",
            borderRadius: 12,
            padding: "8px 10px",
            border: `1px solid ${b.color}22`,
          }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 5 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <span style={{ fontSize: 16 }}>{b.icon}</span>
                <div>
                  <div style={{ color: "#fff", fontSize: 11, fontWeight: 700 }}>{b.name}</div>
                  <div style={{ color: "rgba(255,255,255,0.4)", fontSize: 9 }}>Lv. {b.level}</div>
                </div>
              </div>
              <div style={{
                background: `${b.color}22`, border: `1px solid ${b.color}44`,
                borderRadius: 6, padding: "2px 6px",
                color: b.color, fontSize: 9, fontWeight: 700
              }}>{b.income}</div>
            </div>
            {/* Progress bar */}
            <div style={{ background: "rgba(255,255,255,0.08)", borderRadius: 4, height: 4, overflow: "hidden" }}>
              <div style={{
                height: "100%", width: `${b.progress}%`,
                background: `linear-gradient(90deg, ${b.color}88, ${b.color})`,
                borderRadius: 4, transition: "width 0.5s",
              }} />
            </div>
          </div>
        ))}
      </div>

      {/* Collect Button */}
      <div style={{ background: "#0D1117", padding: "10px 10px 16px", textAlign: "center" }}>
        <div style={{
          background: "linear-gradient(135deg, #FFD700, #FFA502)",
          borderRadius: 14, padding: "10px",
          color: "#1a0a00", fontWeight: 800, fontSize: 13,
          fontFamily: "'Fredoka One', cursive",
          boxShadow: "0 4px 20px #FFD70044",
          cursor: "pointer",
        }}>
          💰 Collect $96.00
        </div>
      </div>
    </div>
  );
};

export default WealthEmpireMock;